export const COST_PER_DAY = 19.9;

export const JOB_COLORS = ['#2563EB', '#D97706', '#7C3AED', '#059669', '#DC2626', '#0891B2', '#CA8A04', '#6D28D9'];
